import { useEffect } from "react";

// Fire the Meta Pixel "Lead" event (call from the button component)
export function trackLead() {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("track", "Lead");
  }
}

export default function useTracking() {
  useEffect(() => {
    // =========================================================
    // Meta Pixel
    // =========================================================
    if (!window.fbq) {
      (function (f, b, e, v, n, t, s) {
        if (f.fbq) return;

        n = f.fbq = function () {
          n.callMethod
            ? n.callMethod.apply(n, arguments)
            : n.queue.push(arguments);
        };

        if (!f._fbq) f._fbq = n;

        n.push = n;
        n.loaded = true;
        n.version = "2.0";
        n.queue = [];

        t = b.createElement(e);
        t.async = true;
        t.src = v;

        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(
        window,
        document,
        "script",
        "https://connect.facebook.net/en_US/fbevents.js"
      );

      window.fbq("init", "398561344199985");
    }

    window.fbq("track", "PageView");

    // =========================================================
    // Marketo Munchkin
    // =========================================================

    const initMunchkin = () => {
      if (window.Munchkin && !window._munchkinInit) {
        window._munchkinInit = true;
        window.Munchkin.init("831-EIJ-807");
      }
    };

    // Munchkin is already loaded
    if (window.Munchkin) {
      initMunchkin();
    } else {
      let munchkinScript = document.getElementById("munchkin-script");

      // Load Munchkin script if it doesn't already exist
      if (!munchkinScript) {
        munchkinScript = document.createElement("script");

        munchkinScript.id = "munchkin-script";
        munchkinScript.type = "text/javascript";
        munchkinScript.async = true;
        munchkinScript.src = "https://munchkin.marketo.net/munchkin.js";

        munchkinScript.onload = initMunchkin;

        document.head.appendChild(munchkinScript);
      } else {
        // Script already exists but Munchkin may still be loading
        const interval = setInterval(() => {
          if (window.Munchkin) {
            clearInterval(interval);
            initMunchkin();
          }
        }, 100);

        setTimeout(() => {
          clearInterval(interval);
        }, 10000);
      }
    }
  }, []);
}